import { PlusOutlined, WechatOutlined } from "@ant-design/icons";
import { Button, Col, Row } from "antd";
import Sider from "antd/es/layout/Sider";

const FactorySider = () => (
    <Sider
        width={225}
        style={{
            backgroundColor: "#ffffff",
            color: "white",
            height: "calc(100vh - 100px)",
            position: "sticky",
            top: 64,
            overflowY: "auto",
        }}
    >
        <div
            style={{
                height: "64px",
                padding: "16px",
                fontSize: "16px",
                fontWeight: "bold",
                backgroundColor: "var(--color-primary)",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
            }}
        >
            <WechatOutlined style={{ marginRight: 6 }} />
            Conversaciones
        </div>
        <Row style={{ margin: "10px" }}>
            <Col span={24}>
                <Button type="primary">
                    <PlusOutlined />
                    Nueva Conversación
                </Button>
            </Col>
        </Row>
    </Sider>
);

export default FactorySider;